import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveButton from '@mui/icons-material/Remove';
import { EditIcon } from "./icons/Icons";
import { fadeInMixin } from "./cssMixins";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';

export const OrdinaryButton = (props) => {
    return <LoadingButton {...props} variant='contained' sx={{ ...fadeInMixin(), ...props.sx, minWidth: '100px', backgroundColor: 'primary', display: 'flex', justifyContent: 'space-evenly' }}>{props.icon}{props.text}</LoadingButton>;
}

export const SaveButton = (props) => {
    return <OrdinaryButton text='Save' {...props} icon={<SaveIcon />} />
}

export const RestoreButton = (props) => {
    return <OrdinaryButton text='Restore' {...props} icon={<RestoreIcon />} />
}

export const CreateButton = (props) => {
    return <Button {...props} variant='contained' sx={{ ...fadeInMixin(), ...props.sx, minWidth: '100px', backgroundColor: 'primary' }}><AddIcon />{props.text}</Button>;
}

export const AddButton = (props) => {
    return <Button {...props} variant='contained' sx={{ ...props.sx, backgroundColor: 'primary.light' }}><AddIcon /></Button>;
}

export const SubstractButton = (props) => {
    return <Button {...props} variant='contained' sx={{ ...props.sx, backgroundColor: 'primary.light' }}><RemoveButton /></Button>;
}

export const EditButton = (props) => {
    return <Button {...props} variant='contained' sx={{ ...props.sx, backgroundColor: 'primary.light' }}><EditIcon />{props.text}</Button>;
}